var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',_vm._b({staticClass:"text-capitalize",attrs:{"color":_vm.color}},'v-chip',_vm.$attrs,false),[_vm._v("\n    "+_vm._s(_vm.value)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }